document.addEventListener('DOMContentLoaded', () => {
  const stickyATC = document.getElementById('StickyATC');
  const stickyButton = document.getElementById('StickyATCButton');
  const mainBuyButtons = document.querySelector('.product-block--buy_buttons');
  const mainForm = document.querySelector('.product-form form');
  const mainSubmitButton = mainForm ? mainForm.querySelector('[name="add"]') : null;

  if (!stickyATC || !mainBuyButtons || !mainSubmitButton) return;

  // Intersection Observer to show/hide sticky ATC
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // If the main buy buttons are OUT of view, show the sticky bar
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyATC.classList.add('sticky-atc--show');
      } else {
        stickyATC.classList.remove('sticky-atc--show');
      }
    });
  }, { threshold: 0 });

  observer.observe(mainBuyButtons);

  // Hook up sticky button to main form submission
  stickyButton.addEventListener('click', () => {
    mainSubmitButton.click();
  });
});
